<template>
  <Tile :product="product" :settings="settings" :dict="dict" :collection-mode="collectionMode"></Tile>
</template>
<script>
import Vue from "vue";
import { mapState } from "vuex";
import Tile from "./Tile.vue";

export default Vue.extend({
  name: "ProductTile",
  components: { 
    Tile 
  },
  props: ["product"],
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {
    ...mapState(["settings", "dict", "collectionMode"])
  }
});
</script>
